import { supabase } from "./supabase";
import { enqueue } from "./outbox";

/* Curriculum lesson-read state (the stored half of the hybrid model). Writes go
   through the SECURITY DEFINER curriculum_mark_read RPC; reads through
   curriculum_progress(). Both own-row, best-effort from the UI. */

export async function markLessonReadRaw(stepId) {
  const { error } = await supabase.rpc("curriculum_mark_read", { p_step_id: stepId });
  if (error) {
    console.warn("curriculum_mark_read failed:", error.message);
    return false;
  }
  return true;
}

export async function markLessonRead(stepId) {
  const ok = await markLessonReadRaw(stepId);
  // Idempotent (on conflict do nothing) → coalesce by step id.
  if (!ok) enqueue({ kind: "curriculum", key: stepId, payload: { stepId } });
  return { ok };
}

/* → Set of step_ids the user has read. */
export async function fetchLessonsRead() {
  const { data, error } = await supabase.rpc("curriculum_progress");
  if (error) {
    console.warn("curriculum_progress fetch failed:", error.message);
    return new Set();
  }
  return new Set((data ?? []).map((r) => r.step_id));
}
